// @flow
import React, {type Node} from 'react';
import classNames from 'classnames';

import s from './menuArrow.scss';

type PropsType = {
    className: string,
};

/**
 * Functional-component for MenuArrowIcon
 * @param {PropsType} props - Received props
 * @returns {Node} - Returned component
 */
export const MenuArrowIcon = (props: PropsType): Node => (
    <div className={classNames(s.wrap, props.className)} />
);

MenuArrowIcon.defaultProps = {
    className: '',
};
